import { IComponentOptions, IController, IOnChangesObjectOf } from "angular";
import { GridContributorType, IAllGoal, OkrGridContributor, OkrMethodologySettings } from "@gtmhub/goals/models";
import { formatAttainmentProgressValue, isContributingMetric } from "@gtmhub/okrs/metrics/utils";
import { Assignee } from "@webapp/assignees/models/assignee.models";
import { getDisplayableOwnerIds } from "@webapp/okrs/utils/utils";

const navStateByContributorType = {
  metric: `._metric.metric({'metricId': contributor.id})`,
  goal: `._goalSidebar.goal({'id': contributor.id})`,
};

interface IOkrGridContributorsComponentBindings {
  contributors: OkrGridContributor[];
  goals: IAllGoal[];
  parent: IAllGoal;
  methodologySettings: OkrMethodologySettings;
  deleteContributor(contributor: OkrGridContributor, goal: IAllGoal): void;
  changeAssignee(item: Assignee, subject: GridContributorType, subjectType: string): void;
  formatAttainmentProgressValue(progress: number): number;
}

// eslint-disable-next-line @typescript-eslint/no-empty-interface
interface OkrGridContributorsComponentCtrl extends IOkrGridContributorsComponentBindings {}
class OkrGridContributorsComponentCtrl implements IController {
  public ownersMap: Record<string, string[]> = {};

  constructor() {
    this.formatAttainmentProgressValue = formatAttainmentProgressValue;
  }

  $onChanges(onChangesObj: IOnChangesObjectOf<OkrGridContributorsComponentCtrl>): void {
    if (onChangesObj.contributors) {
      this.ownersMap = this.contributors.reduce<Record<string, string[]>>((map, contributor) => {
        map[contributor.id] = getDisplayableOwnerIds(contributor, contributor.childType, this.methodologySettings);
        return map;
      }, {});
    }
  }

  getContributorNavState(contributor: OkrGridContributor): string {
    return navStateByContributorType[contributor.childType];
  }

  getIcon(contributor: OkrGridContributor): string {
    return contributor.childType === "goal" ? "goal" : this.getMetricIcon(contributor);
  }

  private getMetricIcon(contributor: OkrGridContributor): string {
    return isContributingMetric(contributor) ? "contributing-metric" : "metric";
  }
}

export const OkrGridContributorsComponent: IComponentOptions = {
  template: require("./okr-grid-contributors.html"),
  controller: OkrGridContributorsComponentCtrl,
  bindings: {
    contributors: "<",
    goals: "<",
    parent: "<",
    methodologySettings: "<",
    deleteContributor: "<",
    changeAssignee: "<",
  },
};
